import { connect } from 'react-redux';
import { compose, withProps, withHandlers } from 'recompose';

import { resetProductBrand, resetProductCategory, setProductSearch } from '../actions';
import { brandOrCategorySelected } from '../selectors';
import SearchInput from '../../../common/SearchInput';
import { t } from '../../../../modules/infra/i18n';

const ProductSearchInput = compose(
  connect(
    (state) => ({
      hasFilters: brandOrCategorySelected(state),
    }),
    {
      resetProductCategory,
      resetProductBrand,
      setSearchTerm: setProductSearch,
    }
  ),
  withProps(() => ({
    placeholder: t('register:sale.product_search.placeholder'),
  })),
  withHandlers({
    onChange: (props) => () => {
      if (props.hasFilters) {
        props.resetProductBrand();
        props.resetProductCategory();
      }
    },
  })
)(SearchInput);

export default ProductSearchInput;
